import React, { Component } from 'react';
import { connect } from 'react-redux';
import { closeModal } from '../../../app/modals/redux/modalActions';
import MSettingPopupForm from './MSettingPopupForm';

const actions = {
  closeModal,
};

class ModalSettingPopup extends Component {
  onDelete = () => {
    const { data, deleteFileWhatsapp, closeModal } = this.props;
    deleteFileWhatsapp(data.auth, data.history, data.item, data.file);
    closeModal();
  };

  render() {
    const { closeModal } = this.props;
    return (
      <div className='modal is-active'>
        <div className='modal-background' onClick={closeModal}></div>
        <div className='modal-card'>
          <header className='modal-card-head'>
            <div className='modal-card-title has-text-info has-text-weight-normal'>
              <i className='is-size-4 mdi mdi-whatsapp icon' /> Whatsapp Status
            </div>
            <button
              onClick={closeModal}
              className='delete'
              aria-label='close'
            ></button>
          </header>
          <section className='modal-card-body is-size-6'>
            <MSettingPopupForm />
          </section>
          <footer className='modal-card-foot'>
            <button
              className='button custom-grey is-small is-rounded is-outlined'
              onClick={closeModal}
            >
              <i className='is-size-6 mdi mdi-arrow-left icon' />
            </button>
          </footer>
        </div>
      </div>
    );
  }
}

export default connect(null, actions)(ModalSettingPopup);
